<template>
  <h5 class="mb-3">
    {{ $t(titleKey) }}
  </h5>
</template>

<script>
export default {
  props: {
    titleKey: {
      type: String,
      required: true
    }
  }
};
</script>
